import { useHistory } from 'react-router-dom';
import logo from '../../assets/img/black-logo.png';

import { Container, Menu, Logo, CopyRight } from './styles';

import Content from '../../components/Content';

const Footer = () => {
  const history = useHistory();
  return (
    <Container>
      <Content>
        <Menu>
          {/* <ul>
            <li>PERGUNTAS FREQUENTES</li>
            <li>TERMOS E CONDIÇÕES DE USO</li>
            <li>POLÍTICA DE PRIVACIDADE</li>
          </ul> */}
          <ul>
            <li onClick={() => history.push('/perguntas-frequentes')}>
              Perguntas frequentes
            </li>
            <li onClick={() => history.push('/termos-de-uso-e-privacidade')}>
              Termos de uso e privacidade
            </li>
            {/* <li onClick={() => window.open('https://t.me/+MmyOBqQrqy4yY2Rh', '_blank')}>
              Telegram
            </li> */}
          </ul>
        </Menu>
        <Logo onClick={() => history.push('/')} src={logo} alt="Worsheep" />
      </Content>
    </Container>
  );
};

export default Footer;
